export function /***/ clearStorage() {
	localStorage.clear();
	// yield put({ type: LOGOUT_OK });
}
